export default "__VITE_ASSET__5fec5329__"